import React, { Fragment, useRef, useState } from 'react';
import clsx from 'clsx';
import { InputRevertButton } from '../../buttons/RevertButton/InputRevertButton';

// TODO: If we convert this component to typescript, we can refactor a lot of duplicate code like we did with TelephoneField.tsx
function EmailField({
    name,
    labelText,
    required = undefined,
    maxLength = undefined,
    autoFocus = undefined,
    readOnly = undefined,
    defaultValue = undefined,
    handleInputChange = undefined,
    handleInputBlur = undefined,
    validateInput = undefined,
    errors = undefined,
    placeholder = undefined,
    onRevert = undefined,
    revertButtonTitle = undefined,
}) {
    const hasErrors = Boolean(errors?.length);
    const inputRef = useRef(null);

    function onChange(e) {
        if (handleInputChange) {
            handleInputChange(e);
        }

        // Only validate on change when there are errors:
        if (hasErrors && validateInput) {
            validateInput(e.target);
        }
    }

    function onBlur(e) {
        if (handleInputBlur) {
            handleInputBlur(e);
        }

        if (validateInput) {
            validateInput(e.target);
        }
    }

    return (
        <div className="form-field">
            <label htmlFor={name}>{labelText}</label>

            <div
                className={clsx(
                    'editing-form-control-nested-control',
                    onRevert && 'input-revert-button__container',
                )}
            >
                <input
                    className={clsx('form-control', hasErrors && 'input-validation-error')}
                    id={name}
                    name={name}
                    type="email"
                    required={required}
                    onChange={onChange}
                    onBlur={onBlur}
                    autoFocus={autoFocus}
                    readOnly={readOnly}
                    defaultValue={defaultValue}
                    placeholder={placeholder}
                    data-label-text={labelText}
                    maxLength={maxLength}
                    ref={inputRef}
                />
                {onRevert && (
                    <InputRevertButton onClick={() => onRevert(inputRef.current)} title={revertButtonTitle} />
                )}

                {hasErrors && (
                    <div className="field-validation-error">
                        {errors.map((error) => (
                            <Fragment key={error}>
                                {error}
                                <br />
                            </Fragment>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export { EmailField };
